import React, { createContext, useEffect, useState } from "react";
import APIS from "../apis";

export const MasterContext = createContext();

// eslint-disable-next-line react/prop-types
export const MasterProvider = ({ children }) => {
  const [etat, setEtat] = useState(null); // null = loading
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEtat = async () => {
      try {
        const resAnnee = await APIS.get("annee/select_annee_precedente");
        const annee_id = resAnnee.data.Annee[0].CurrentAnnee[0].value;

        const resMastere = await APIS.post(
          "master/fermeture_formulaire",
          { annee_id }
        );

        setEtat(resMastere.data.Master); // 0 ouvert / 1 fermé
      } catch (e) {
        console.error(e);
        setEtat(1);
      } finally {
        setLoading(false);
      }
    };

    fetchEtat();
  }, []);


  return (
    <MasterContext.Provider value={{ etat, loading }}>
      {children}
    </MasterContext.Provider>
  );
};
